<nav class="navbar fixed-top navbar-toggleable-md navbar-dark nav-shadow nav-background row m-0 p-0 py-sm-2 px-sm-3">
    <div class="d-flex align-items-center">
        @if (user) {
            <span class="toggle-menu mx-3" (click)="onToggleSidebar()">
                <fa-icon [icon]="['fas', 'bars']"></fa-icon>
            </span>
        }
        <a class="navbar-brand" routerLink="/home">
            <h5 class="m-0">
                <span class="mr-3">BulPCS</span>
                @if (displayBuildInfo) {
                    <span class="badge badge-light" [ngClass]="buildInfo">
                        {{ buildInfo | lowercase | translate }}
                    </span>
                }
            </h5>
        </a>
    </div>
    @if (!user && notificationsCount) {
        <div class="text-center">
            <div
                class="alert alert-primary alert-dismissible fade show px-2"
                role="alert"
                (click)="openNotificationsGridModal()">
                <span class="align-middle">
                    <fa-icon class="text-danger pr-1" [icon]="['fas', 'exclamation-circle']"></fa-icon>
                    <strong>
                        <span class="d-none d-xl-inline">{{ 'You have' | translate }}</span>
                        {{ notificationsCount }}
                        <span class="d-none d-lg-inline">{{ 'important' | translate }}</span>
                        <span class="d-none d-sm-inline">
                            {{ (notificationsCount > 1 ? 'notices' : 'notice') | translate }}.
                        </span>
                    </strong>
                </span>
                <button class="d-none d-sm-inline btn btn-xs btn-primary" type="button">
                    {{ 'View' | translate }}
                </button>
            </div>
        </div>
    }
    <div class="d-flex align-items-center justify-content-end">
        <button
            class="btn btn-sm text-white"
            kendoTooltip
            title="{{ 'Toggle Dark Mode' | translate }}"
            (click)="toggleDarkMode()">
            @if (!dark) {
                <fa-icon [icon]="['fas', 'moon']"></fa-icon>
            }
            @if (dark) {
                <fa-icon [icon]="['fas', 'sun']"></fa-icon>
            }
        </button>
        <button
            class="btn btn-sm text-white"
            kendoTooltip
            title="{{ 'Change Language' | translate }}"
            (click)="changeLanguage()">
            <fa-icon [icon]="['fas', 'language']"></fa-icon>
        </button>
        @if (user) {
            <kendo-dropdownbutton class="header-dropdown-button" [data]="profileMenuItems">
                <i class="fa fa-user"></i>
                <span class="d-none d-sm-inline name ml-2">
                    {{ user.fullName ? user.fullName : user.userName }}
                </span>
                <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                    @if (dataItem === 'account') {
                        <a class="dropdown-item w-100" translate [routerLink]="['/profile']">
                            <i class="fa fa-user mr-2"></i>
                            Account
                        </a>
                    }
                    @if (dataItem === 'sign-out') {
                        <a class="dropdown-item w-100" translate (click)="logout()">
                            <i class="fa fa-sign-out mr-2" aria-hidden="true"></i>
                            Sign Out
                        </a>
                    }
                </ng-template>
            </kendo-dropdownbutton>
        }
    </div>
</nav>
